import createIcon from '../../createIcon';

/**
 * @component @name ArrowForwardIos
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNi4xMTUyMyAyMC4yM0w3Ljg4NTIzIDIyTDE3Ljg4NTIgMTJMNy44ODUyMyAyTDYuMTE1MjMgMy43N0wxNC4zNDUyIDEyTDYuMTE1MjMgMjAuMjNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ArrowForwardIos = createIcon('ArrowForwardIos', [
  [
    'path',
    {
      d: 'M6.11523 20.23L7.88523 22L17.8852 12L7.88523 2L6.11523 3.77L14.3452 12L6.11523 20.23Z',
      key: '1f1gqj',
    },
  ],
]);

export default ArrowForwardIos;
